import {Injectable} from '@angular/core';
import {CommonErrorResolver, ErrorResponse} from '../../../../common/providers';

@Injectable()
export class DashboardErrorResolver extends CommonErrorResolver {

    protected resolveBadRequestErrors(response: ErrorResponse): ErrorResponse {
        switch (response.code) {
            case 'ERR004':
            case 'ERR009':
            case 'ERR005':
            case 'ERR010':
            case 'ERR013':
            case 'ERR022':
            case 'ERR023':
            case 'ERR025':
            case 'ERR028':
            case 'ERR045':
            case 'ERR047':
            case 'ERR049':
            case 'ERR053':
            case 'ERR054':
            case 'ERR055':
            case 'ERR058':
            case 'ERR059':
            case 'ERR060':
            case 'ERR061':
            case 'ERR062':
            case 'ERR063':
            case 'ERR068':
            case 'ERR069':
            case 'ERR070':
            case 'ERR072':
            case 'ERR075':
            case 'ERR077':
            case 'ERR078':
            case 'ERR079':
            case 'ERR080':
            case 'ERR081':
            case 'ERR083':
            case 'ERR084':
            case 'ERR085':
            case 'ERR138':
            case 'ERR139':
            case 'ERR140':
            case 'ERR141':
            case 'ERR142':
            case 'ERR143':
            case 'ERR144':
            case 'ERR145':
            case 'ERR146':
            case 'ERR147':
            case 'ERR148':
            case 'ERR149':
            case 'ERR157':
            case 'ERR158':
            case 'ERR168':
            case 'ERR169':
            case 'ERR175':
            case 'ERR176':
            case 'ERR177':
            case 'ERR178':
            case 'ERR180':
            case 'ERR181':
            case 'ERR306':
            case 'ERR308':
            case 'ERR309':
            case 'ERR320':
            case 'ERR310':
            case 'ERR350':
            case 'ERR351':
            case 'ERR352': {
                return response;
            }

            default:
                return super.resolveBadRequestErrors(response);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/error/dashboard.error.resolver.ts